import { render, staticRenderFns } from "./NomadIndex.vue?vue&type=template&id=25198fe2"
import script from "./NomadIndex.vue?vue&type=script&lang=js"
export * from "./NomadIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports